import { CreateValidationObject, Translation } from '@/helpers'

export const NameValidation = (value: string): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    const minLength = 3
    const maxLength = 62

    if (value?.length > maxLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('can-not-have-more-than')} ${maxLength} ${Translation('characters')}!`
    }

    if (value?.length < minLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('needs-to-be-at-least')} ${minLength} ${Translation('characters')}!`
    }

    return validation
}

export const TagValidation = (value: string): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    const minLength = 2
    const maxLength = 32

    if (!/^[a-zA-Z0-9.,'"\[\]()_-]+(?: [a-zA-Z0-9.,'"\[\]()_-]+)* *$/.test(value)) {
        validation.error = true
        validation.message = Translation('tag-regex-validation')
    }

    if (value?.length > maxLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('can-not-have-more-than')} ${maxLength} ${Translation('characters')}!`
    }

    if (value?.length < minLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('needs-to-be-at-least')} ${minLength} ${Translation('characters')}!`
    }

    return validation
}

export const CategoryNameValidation = (value: string): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    const minLength = 4
    const maxLength = 52

    if (!/^[a-zA-Z0-9.,'"\[\]()_-]+(?: [a-zA-Z0-9.,'"\[\]()_-]+)* *$/.test(value)) {
        validation.error = true
        validation.message = Translation('category-name-regex-validation')
    }

    if (value?.length > maxLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('can-not-have-more-than')} ${maxLength} ${Translation('characters')}!`
    }

    if (value?.length < minLength) {
        validation.error = true
        validation.message = `${Translation('name')} ${Translation('needs-to-be-at-least')} ${minLength} ${Translation('characters')}!`
    }

    return validation
}

export const PriceValidation = (value: string): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    const minValue = 0
    const maxValue = 999

    if (parseInt(value) < minValue) {
        validation.error = true
        validation.message = `${Translation('price')} ${Translation('cant-be-less-than')} ${minValue}!`
    }

    if (parseInt(value) > maxValue) {
        validation.error = true
        validation.message = `${Translation('price')} ${Translation('cant-be-more-than')} ${maxValue}!`
    }

    if (value?.toString().trim() === '') {
        validation.error = true
        validation.message = Translation('price-is-not-valid')
    }

    return validation
}

export const LinkValidation = (value: string): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    if (value?.trim() !== '') {
        if (!/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/.test(value)) {
            validation.error = true
            validation.message = Translation('link-regex-validation')
        }
    }

    return validation
}

export const TagsValidation = () => {
    return CreateValidationObject()
}

export const CategoryValidation = (value: string) => {
    const validation = CreateValidationObject()

    if (
        value?.trim() === '' ||
        value === null ||
        value === undefined ||
        value?.trim().length === 0
    ) {
        validation.error = true
        validation.message = Translation('category-is-required')
    }

    return validation
}

export const ImageValidation = (value: string | null | undefined | File): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    if (value === null || value === undefined || typeof value === 'string' && value?.trim() === '') {
        validation.error = true
        validation.message = Translation('image-is-required')
    }

    return validation
}

export const VideoValidation = (value: string | null | undefined | File): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    if (value === null || value === undefined || typeof value === 'string' && value?.trim() === '') {
        validation.error = true
        validation.message = Translation('video-is-required')
    }

    return validation
}

export const ClipboardValidation = (value: string | null | undefined | File): ValidationFunctionObjectReturnTypes => {
    const validation = CreateValidationObject()

    if (value === null || value === undefined || typeof value === 'string' && value?.trim() === '') {
        validation.error = true
        validation.message = Translation('clipboard-is-required')
    }

    return validation
}
